module.exports = __webpack_public_path__ + "static/media/wing-chun.ddaac902.jpg";